import { CityUserController } from "./CityUserController";

export class CityDetails {

    constructor(store) {
        this.store = store;
        this.container = document.createElement("div");
        this.container.className = "sectionColumn";
        this.container.id = 'CITYDETAILSCONTAINER'
        this.colleagues = null;
        this.cityUserController = new CityUserController(this.store);
         this.store.cityUserController = this.cityUserController;
    }

    async render(cityid) {
        this.container.innerHTML = "";
        const cityTitle = document.createElement("div");
         cityTitle.className = this.store.config.isSmall ? 
         "wrapper width-100 height-10 column border-bottom margin-bottom-1 padding-left- padding-right-2 padding-bottom-1 font-17 weight-600 margin-right-5 color-50" 
         : "wrapper width-100 height-10 column border-bottom margin-bottom-1 padding-left-5 padding-right-2 padding-bottom-1 font-35 weight-600 margin-right-5 color-50";

        cityTitle.id = 'CITYTITLE'
        cityTitle.textContent = this.store.level.selectedCity?.name ?? "";
        this.container.appendChild(cityTitle);

        const wrapper = document.createElement("div");
        wrapper.id = "CITYDETAILSWRAPPER";
        wrapper.className = "width-100 height-85 row align-top";
        this.container.appendChild(wrapper);
        //LISTÁK
        this.section = document.createElement("div");
        this.section.className = "width-100 height-100 row align-top";

        try {
            const items = await this.store.datas.filter('INVENTORY', 'officeid', parseInt(cityid));
            const devices = await this.store.datas.filter(items, 'type', "IT");
            const furnitures = await this.store.datas.filter(items, 'type', "FURNITURE");
            this.colleagues = await this.store.datas.getUsersByCityid(parseInt(this.store.level.selectedCity.id))
            //HA NINCS MÉG A TELEPÜLÉSEN HOZZÁADÁS
            if(this.store.level.cityCaller === 'OFFICE'){
                this.colleagues.push({name: 'KOLLÉGA HOZZÁADÁSA A TELEPÜLÉSHEZ'})
            }else if(this.store.level.cityCaller === 'USER'){
                if(this.store.level.selectedColleague !== null){
                    const exists = this.colleagues.some(colleague => colleague.id === this.store.level.selectedColleague.id);
                    if(!exists){this.colleagues.push({name: 'KOLLÉGA HOZZÁADÁSA A TELEPÜLÉSHEZ'})}
                }
            }
            this.section.appendChild(this.renderList("IT eszközök", devices, item => `${item.category} - ${item.barcode}`, "INVENTORY"));
            this.section.appendChild(this.renderList("Bútorok", furnitures, item => `${item.model} - ${item.barcode}`, "INVENTORY"));
            this.section.appendChild(this.renderList("Kollégák", this.colleagues, colleague => colleague.name, "USER"));
            this.store.level.cityColleagues = this.colleagues;
            wrapper.appendChild(this.section);
        } catch(err) {console.error(err);}
        return this.container;
    }

    renderList(title, list, formatter, type) {
        const column = document.createElement("div");
        column.className = "list-row-container";
        const header = document.createElement("div");
        header.className = "section-title";
        header.textContent = title;
        const listContainer = document.createElement("div");
        listContainer.className = "font-5";
        list.forEach(item => {
            const row = document.createElement("div");
            row.className = "list-row";
        
            // A sor tartalma
            const name = document.createElement("span");
            name.textContent = formatter(item);
            row.appendChild(name);

            // KOLLÉGÁKHOZ A TÖRLÉS GOMB
            if (type === "USER" && item.id) {
                const button = document.createElement("img");
                button.src = "/assets/buttonNO.png";
                button.alt = "Kolléga eltávolítása";
                Object.assign(button.style, this.store.config.isSmall ? {width: "16px", height: "16px", cursor: "pointer", marginLeft: "6px"} : {width: "25px", height: "25px", cursor: "pointer", marginLeft: "10px"});
                button.addEventListener("click", (e) => {
                    e.stopPropagation();
                    this.store.cityUserController.removeColleague(this.store.level.selectedCity.id, item.id)
                });
                row.appendChild(button);
            }
            row.addEventListener("mouseenter", () => {row.style.background = "rgba(255,245,160,.25)";});
            row.addEventListener("mouseleave", () => {row.style.background = "transparent";});
            row.addEventListener("click", (e) => {
                this.section.className = "sectionColumn";
                if (type === "INVENTORY") {
                    // AZ INVENTORYFORM NÉZI
                    this.store.level.formType = item.type;
                    this.store.modalController.setLayout({layout: "MODALOPENWITHDETAILS", component: "showinventory", data: item});
                } else if (type === "USER") {
                    if(item.name !== 'KOLLÉGA HOZZÁADÁSA A TELEPÜLÉSHEZ'){
                        this.store.level.selectedColleague = item;
                        this.store.modalController.setLayout({layout: "MODALOPENWITHDETAILS", component: "__SET__", data: this.store.level.selectedColleague});
                    }else{
                        // CITYUSERS HA OFFICE-RÓL INDÍTOM -> A LEVELCONTROLLER CITYUSER SZINTJE MEGJELNÍTI AZ AKTUÁLIS IRODÁT, A USERRE KATTINTVA AZ INPUTSYSTEM COLLEAGUE ÁGA MEGHÍVJA A CITIY.ONCITYCHANGE-T
                        this.store.level.cityuser = true;
                        this.store.levelController.setLevel({name: "CITYUSER", office: null, position: null});
                        this.store.level.levelName = "CITYUSER";
                    }
                }
            });
            listContainer.appendChild(row);
        });
        column.appendChild(header);
        column.appendChild(listContainer);
        return column;
    }
}